import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../Login";
import { useApi } from "../../hooks/useApi";
import { toast } from "react-toastify";
import AlertModal from "../../components/Modal/AlertModal";
import Loader from "../../components/DefaultStyles/Loader";
import ExcelDownload from "../../components/DefaultStyles/ExcelDownload";
import Flex from "../../components/DefaultStyles/Flex";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import { TotalCount } from "../Users/UserInfo";
import { getThousandComma } from "../../ApiTS/ApiCommonTS";
import Pagination from "../../components/Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import LineBtn from "../../components/Button/LineBtn";
import CheckBox from "../../components/Button/CheckBox";
import LineBox from "../../components/DefaultStyles/LineBox";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import DotStatus from "../../components/DefaultStyles/DotStatus";
import dayjs from "dayjs";
import { uplusState } from "../../Enum/state.Enum";
import OldUplusMatchingInfoFilter from "../../components/pages/Party/OldUplusMatchingInfo/OldUplusMatchingInfoFilter";

export interface IOldUplus {
  enddate?: string;
  id: string;
  name: string;
  nickname: string;
  phoneNum: string;
  ratePlan: string;
  reason: string;
  regName: string;
  reqDate: string;
  startdate?: string;
  state: number;
  uid: string;
  updatedate: string;
  writer: string;
  key: string;
  birthday: string;
}

export const oldUplusMatchingPageState = atom<number>({
  key: "oldUplusMatchingPageState",
  default: 0,
});

export default function OldUplusMatchingInfo() {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);
  const [savedPage, setSavedPage] = useRecoilState<number>(oldUplusMatchingPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(page);
  }, [page]);
  const [filter, setFilter] = useState({
    searchType: "",
    searchValue: "",
    stateValue: "",
    startdate: "",
    enddate: "",
  });

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: auth?.uplus
      ? `uplus?page=${page}&size=10` +
        (filter?.searchValue !== ""
          ? `&${filter?.searchType}=${filter?.searchValue}`
          : ``) +
        (filter?.stateValue !== "" ? `&state=${filter?.stateValue}` : ``) +
        (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
          ? `&startdate=${filter?.startdate}&enddate=${dayjs(filter?.enddate)
              ?.add(1, "day")
              ?.format("YYYY-MM-DD")}`
          : ``)
      : undefined,
  });

  const [selected, setSelected] = useState<{ [key: number]: any }>({});
  const [viewKey, setViewKey] = useState({
    modal: false,
    key: "",
  });

  console.log(selected);

  const tableHead = [
    filter?.stateValue === "1" ||
    filter?.stateValue === "2" ||
    filter?.stateValue === "3"
      ? "선택"
      : "",
    "ID",
    "Key",
    "신청자",
    "등록 이름",
    "등록 전화번호",
    "등록 생년월일",
    "결합 상태",
    "사유",
    "매칭 신청일",
    "결합 시작일",
    "결합 종료일",
    "최종 업데이트",
    "담당자",
  ];

  const excelHead = tableHead?.filter(
    (a) =>
      a !== "" &&
      a !== "선택" &&
      a !== "ID" &&
      a !== "신청자" &&
      a !== "최종 업데이트"
  );

  useEffect(() => {
    if (error) {
      toast.error(
        error?.data ?? "유플러스 결합 정보를 가져오는 데에 실패하였습니다."
      );
    }
  }, [error]);

  return (
    <>
      <PageTitle title="구. 유플러스 결합" />

      <OldUplusMatchingInfoFilter
        filter={filter}
        setFilter={setFilter}
        pageResetEvent={() => {
          setPage(0);
        }}
        selectedKey={selected}
        selectedResetEvent={() => setSelected({})}
        itemLength={response?.data?.items?.length}
        fetchData={() =>
          fetchData({
            method: "get",
            url:
              `uplus?page=${page}&size=10` +
              (filter?.searchValue !== ""
                ? `&${filter?.searchType}=${filter?.searchValue}`
                : ``) +
              (filter?.stateValue !== ""
                ? `&state=${filter?.stateValue}`
                : ``) +
              (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
                ? `&startdate=${filter?.startdate}&enddate=${dayjs(
                    filter?.enddate
                  )
                    ?.add(1, "day")
                    ?.format("YYYY-MM-DD")}`
                : ``),
          })
        }
      />

      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {response?.data?.items?.map((d: IOldUplus, index: number) => {
              return (
                <TableBody key={d?.id}>
                  {(filter?.stateValue === "1" ||
                    filter?.stateValue === "2" ||
                    filter?.stateValue === "3") && (
                    <TableBodyItem>
                      <CheckBox
                        checked={selected?.[index]}
                        onChange={() => {
                          if (selected?.[index]) {
                            setSelected({
                              ...selected,
                              [index]: null,
                            });
                          } else {
                            setSelected({
                              ...selected,
                              [index]: d?.key,
                            });
                          }
                        }}
                      />
                    </TableBodyItem>
                  )}

                  <TableBodyItem>{d?.id}</TableBodyItem>

                  <TableBodyItem>
                    <LineBtn
                      btnText="보기"
                      btnClickEvent={() =>
                        setViewKey({
                          modal: true,
                          key: d?.key ?? "",
                        })
                      }
                    />
                  </TableBodyItem>
                  <TableBodyItem
                    isKeepAll={true}
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid ?? 0}`);
                    }}
                  >
                    {d?.uid}_{d?.name}_{d?.nickname}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>{d?.regName}</TableBodyItem>
                  <TableBodyItem>
                    {d?.phoneNum?.length > 0 ? d?.phoneNum : `-`}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.birthday?.length > 0
                      ? dayjs(d?.birthday).format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem style={{ minWidth: 89 }}>
                    <DotStatus
                      size="sm"
                      color={
                        d?.state === 1
                          ? "#ffb100"
                          : d?.state === 2
                          ? "#00c7c7"
                          : d?.state === 3
                          ? "#858c97"
                          : "#f42d16"
                      }
                      text={uplusState[d?.state]}
                    />
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.reason?.length > 0 ? d?.reason : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {dayjs(d?.reqDate ?? undefined)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.startdate!?.length > 0
                      ? dayjs(d?.startdate).format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {d?.enddate
                      ? dayjs(d?.enddate ?? undefined)?.format("YYYY-MM-DD")
                      : "-"}
                  </TableBodyItem>
                  <TableBodyItem isKeepAll={true}>
                    {dayjs(d?.updatedate ?? undefined)?.format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    {d?.writer?.length > 0 ? d?.writer : "-"}
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response?.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      <SpaceBetween>
        <div />

        <Flex gapSize={10}>
          <ExcelDownload
            tableHead={excelHead}
            pushedData={(e: any) => {
              return [
                e.key,
                e.regName,
                e?.phoneNum?.length > 0 ? e?.phoneNum : `-`,
                e?.birthday?.length > 0
                  ? dayjs(e?.birthday).format("YYYY-MM-DD")
                  : "-",
                uplusState[e?.state],
                e?.reason?.length > 0 ? e?.reason : "-",
                dayjs(e?.reqDate ?? undefined)?.format("YYYY-MM-DD HH:mm:ss"),
                e?.startdate!?.length > 0
                  ? dayjs(e?.startdate).format("YYYY-MM-DD")
                  : "-",
                e?.enddate
                  ? dayjs(e?.enddate ?? undefined)?.format("YYYY-MM-DD HH:mm")
                  : "-",
              ];
            }}
            dataUrl={
              `uplus?page=0&size=1000` +
              (filter?.searchValue !== ""
                ? `&${filter?.searchType}=${filter?.searchValue}`
                : ``) +
              (filter?.stateValue !== ""
                ? `&state=${filter?.stateValue}`
                : ``) +
              (filter?.enddate !== "" && !filter?.enddate?.includes("선택")
                ? `&startdate=${filter?.startdate}&enddate=${dayjs(
                    filter?.enddate
                  )
                    ?.add(1, "day")
                    ?.format("YYYY-MM-DD")}`
                : ``)
            }
            disabled={
              response?.data?.items?.length < 1 || !response?.data?.items
            }
            title="유플러스 결합"
          />
        </Flex>
      </SpaceBetween>

      {viewKey?.modal && (
        <AlertModal
          title={"Key"}
          desc={viewKey?.key ?? ""}
          customCancelBtn={<></>}
          btnColor="mint"
          isSmallDesc={13}
          confirmEvent={() =>
            setViewKey({
              modal: false,
              key: "",
            })
          }
        />
      )}

      {loading && <Loader />}
    </>
  );
}
